import { Component, ViewEncapsulation } from '@angular/core';
import { UserService } from './services';

@Component({
    selector: 'app',
    styles:[`
        :host {
            height: 100%;
            display: flex;
            flex-direction: column;
        }
    `],
    encapsulation: ViewEncapsulation.None,
    template: `<router-outlet></router-outlet>`
})
export class App {
    
    constructor(userService: UserService){
        userService.isLoggedIn().subscribe();
    }
}
